export const DATA_TABLE_STYLE_TYPE = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary'
};